import "./App.css";
import Header from "./header";
import Main from "./main";
import axios from "axios";
import Footer from "./footer";
import { useEffect, useState } from "react";
function App() {
  const [backcolor, setbackcolor] = useState("#0b0f14");
  const [border, setborder] = useState(" #00e5ff");
  const [flight, setflight] = useState([]);
  const [lastupdate, setlastupdate] = useState(null);
  const [search, setsearch] = useState("");
  useEffect(() => {
    const fetchFlight = () => {
      axios
        .get("https://flight-backend-1-hc9v.onrender.com/flights")
        .then((res) => {
          setflight([...res.data.flights]);
          // console.log(res.data.flights, "2");
          setlastupdate(new Date().toLocaleTimeString());
        });
    };
    fetchFlight();
    const interval = setInterval(fetchFlight, 15000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div
      className="App"
      style={{
        width: "100vw",
        height: "100vh",
        margin: "0px",
        padding: "0px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header backcolor={backcolor} border={border}></Header>
      <Main
        flight={flight}
        backcolor={backcolor}
        lastupdate={lastupdate}
        border={border}
        search={search}
      ></Main>
      <Footer
        backcolor={backcolor}
        search={search}
        setsearch={setsearch}
        setbackcolor={setbackcolor}
        border={border}
        setborder={setborder}
      ></Footer>
    </div>
  );
}

export default App;
